import Fetcher from "@yy/fetcher";
import Cookies from "js-cookie";

export const paths = {
  user: {
    userRole: "//www.yy.com/zone/userinfo/getUserType.json",
    userInfo: "//www.yy.com/zone/userinfo/getUserInfo.json",
    settleSwitch: "//www.yy.com/zone/common/settleSwitch.json",
  },
  yyClientTicket: "//www.yy.com/zone/guild/air/ticket.action",
  certStatus: "//www.yy.com/zone/userinfo/getCertStatus.json",
  getStarGuildUpCondition: "//www.yy.com/zone/guild/checkStarGuildUpGradeV2.json",
  regGuild: "//www.yy.com/zone/guild/regGuild.json",
  regStarGuild: "//www.yy.com/zone/guild/starGuildUpgradeV2.json", // 适用普通公会升级到星级
  directRegStarGuild: "//www.yy.com/zone/guild/directUpgradeStarGuild.json", // 直接升级星级公会接口，适用普通用户升级到星级
  amount: "//www.yy.com/zone/guild/deposit/amount.action",
  payment: "//www.yy.com/zone/guild/deposit/money/pay.action",
  orderStatus: "//www.yy.com/zone/guild/deposit/money/pay/order/status.action",
  roleBlacklist: "//www.yy.com/zone/userinfo/roleBlacklist.json",
};

const cloudLogConfig =
  process.env.NODE_ENV === "production"
    ? {
        url: "//www.yy.com/zone/cloudlog/api/log/put",
        encode: "2",
        logStore: "usercenterguide",
        project: "yylive-weblog",
        region: "cn-shenzhen",
        getUid: () => Cookies.get("yyuid") as string,
      }
    : undefined;

const fetcher = new Fetcher({ paths, cloudLogConfig });
export default fetcher;
